<template>
  <div class="page_container Xcontent-box">
    <div class="content-box">
      <LLMReports />
    </div>
  </div>
</template>

<script>
import LLMReports from '../reports/LLMReports.vue';

export default {
  components: {
    LLMReports,
  },
};
</script>

<style></style>
